import { RichTextValue } from '@/components';
import { useGetArticleDetailsQuery } from '@/redux/articles';
import { Tag } from 'antd';

interface Props {
  id: string;
}

export function ArticleOverviewDetailsPanel(props: Props) {
  const { id } = props;
  const { data } = useGetArticleDetailsQuery({ id });

  if (!data) {
    return null;
  }

  const { description } = data;

  return (
    <>
      {data.shortDescription && (
        <Tag color="blue" className="ms-3">
          {data.shortDescription}
        </Tag>
      )}

      <RichTextValue
        label={false}
        value={description}
        ownerId={id}
        ownerType="Article"
      />
    </>
  );
}
